
import axios from "axios";
import { apis } from "../constants/apis";
import httpService from "./httpService";
import { LocalStorageKey } from "../constants/localStorageKeys";
import { withServicePrefix } from "../helpers/common";
import { vmrsDelete, vmrsGet, vmrsPost } from "./vmrsApi";

export async function addImgIntoCart(payload: any)
{
  return vmrsPost(`${apis.cart.addImage}`, payload);

  // const staticConfigs = JSON.parse(localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? '');
  // const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL
  // return axios.post(`${baseUrl}${withServicePrefix(apis.cart.addImage)}`, payload);
}

export async function delImgIntoCart(payload: any)
{
  return vmrsDelete("/api/v1/carts/remove/items", { data: payload });

  // const staticConfigs = JSON.parse(localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? '');
  // const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL


  // return axios.delete(`${baseUrl}${withServicePrefix("/api/v1/carts/remove/items")}`, { data: payload });
}

export async function getImgs(payload: any)
{
  return vmrsGet(`${apis.cart.getImage}`, payload);

  // const staticConfigs = JSON.parse(localStorage.getItem(LocalStorageKey.STATIC_CONFIG) ?? '');
  // const baseUrl = staticConfigs?.REACT_APP_API_BASE_URL
  // return axios.get(`${baseUrl}${withServicePrefix(apis.cart.getImage)}`, payload);
}

export async function getProductBundleByItemType(payload: any)
{
  return httpService.get(
    `${apis.cart.getProductBunbleByItemType}/${payload?.itemType}`
  );
}
